import React from 'react';

import { useSelector } from 'react-redux';

import { useActions } from '../../../../../../shared/hooks';
import { selectSummarizationModalId } from '../../selectors';
import { setIsSummarizationModalClosedAction } from '../../slice';
import { SummarizationModal, SummarizationModalId } from '../../types';
import { SummarizationStartModal } from '../summarization-start-modal';
import { SummarizationStopModal } from '../summarization-stop-modal';
import { SummarizationWelcomeModal } from '../summarization-welcome-modal';

const modalsMap: Record<SummarizationModalId, SummarizationModal> = {
    WELCOME: SummarizationWelcomeModal,
    START: SummarizationStartModal,
    STOP: SummarizationStopModal,
};

export function SummarizationModalsManager() {
    const modalId = useSelector(selectSummarizationModalId);
    const { closeModal } = useActions({ closeModal: setIsSummarizationModalClosedAction });

    if (!modalId) {
        return null;
    }

    const SummarizationModal = modalsMap[modalId];

    return <SummarizationModal onClose={closeModal} />;
}
